import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ZoomApp from '../../components/ZoomApp/ZoomApp';
import { resetDocumentZoom } from '../../components/ZoomApp/zoomDocument';
import useSearchPlayers from '../../hooks/useSearchPlayers';
import V2Icon from './V2Icon';
import V2PlayerSearch from './V2PlayerSearch';
import classNames from 'classnames';
import { setPortableMode } from '../../containers/App/actions';
import Randomizer from '../../components/Randomizer/Randomizer';
import V2AutopasteSwitch from './V2AutopasteSwitch';
import { pokerSitePostfix } from '../../containers/StatPage/utils';

const V2PortableHeader = React.memo(() => {
  const { t } = useTranslation('translation');
  const dispatch = useDispatch();

  const {
    nicknameToFind,
    searchPlayer,
    focusPlayerSearch,
    blurPlayerSearch,
    selectPlayer,
    options,
    clearAutocompletePlayers,
  } = useSearchPlayers();

  const handleClosePortableMode = React.useCallback(() => {
    resetDocumentZoom();
    dispatch(setPortableMode(false));
  }, [dispatch]);

  const searchOptions = React.useMemo(
    () =>
      options.map((option) => ({
        id: option.value,
        label: option.player.playername,
        subtitle: pokerSitePostfix[option.player.pokersiteId],
        href: option.href,
      })),
    [options],
  );

  const handleSelectPlayer = React.useCallback(
    (id: number) => {
      selectPlayer(id);
      clearAutocompletePlayers();
    },
    [clearAutocompletePlayers, selectPlayer],
  );

  return (
    <header className="PortableHeader">
      <div className="portable-toolbar">
        <div className="portable-toolbar__zoom">
          <ZoomApp orientation="horizontal" compact />
        </div>

        <div className="portable-toolbar__search">
          <V2PlayerSearch
            variant="compact"
            inputId="portable-search-player"
            query={nicknameToFind ?? ''}
            onQueryChange={searchPlayer}
            onSubmit={() => undefined}
            options={searchOptions}
            onSelectOption={handleSelectPlayer}
            onFocus={focusPlayerSearch}
            onBlur={() => {
              blurPlayerSearch();
              clearAutocompletePlayers();
            }}
            emptyNote="Игрок не найден."
          />
        </div>

        <div className="portable-toolbar__actions">
          <Randomizer variant="chip" />
          <V2AutopasteSwitch />
          <button
            type="button"
            className={classNames(
              'workspace-tool workspace-tool--portable',
              'workspace-tool--active',
            )}
            onClick={handleClosePortableMode}
            aria-label={t('exit_portable_mode')}
            title={t('exit_portable_mode')}
          >
            <V2Icon name="compact" />
          </button>
        </div>
      </div>
    </header>
  );
});

export default V2PortableHeader;
